export enum ReleaseEnvironment {
    Development = "Development",
    Production = "Production"
}